export default {
  mainCountryModalTitle: {
    id: 'bo_seller_profile_page_tax_residence_main_country_modal_title',
    defaultMessage: 'Add country of tax residence',
  },
  updatingMainCountry: {
    id: 'bo_seller_profile_page_tax_residence_main_country_updating',
    defaultMessage: 'Updating your tax residence country...',
  },
  mainCountryLabel: {
    id: 'bo_seller_profile_page_tax_residence_main_country_label',
    defaultMessage: 'Country',
  },
  submitButton: {
    id: 'bo_seller_profile_page_tax_residence_main_country_submit_button',
    defaultMessage: 'Add country',
  },
  cancelButton: {
    id: 'bo_seller_profile_page_tax_residence_main_country_cancel_button',
    defaultMessage: 'Cancel',
  },
  mainCountryUpdateSuccessTitle: {
    id: 'bo_seller_profile_page_tax_residence_main_country_update_success_title',
    defaultMessage: 'Country of tax residence added ✔️',
  },
  mainCountryUpdateSuccessContent: {
    id: 'bo_seller_profile_page_tax_residence_main_country_update_success_error',
    defaultMessage: 'Nice work.',
  },
  required: {
    id: 'bo_seller_profile_page_tax_residence_main_country_required',
    defaultMessage: 'Please select a country.',
  },
}
